<template>
    <section :ref="id" class="ui-sidebar" :class="status ? 'active' : ''">
        <div v-show="showOverlay" class="sidebar-overlay" @click="overlayClose ? closeHandle() : ''"/>
        <div class="sidebar" :class="[position, {'shadow': !showOverlay}]">
            <!-- header -->
            <div class="header">
                <div>
                    <h2><i v-if="icon" :class="icon"/>{{title}}</h2>
                    <p v-if="text">{{text}}</p>
                </div>
                <div>
                    <button type="button" @click="closeHandle">
                        <i class="fal fa-times"/>
                    </button>
                </div>
            </div>
            <!-- Tabs -->
            <ui-sidebar-tabs v-if="tabsTotal" :tabs="tabsLabel"/>
            <!-- Before Body -->
            <slot name="beforeBody"/>
            <!-- Body -->
            <div class="body scroll-color">
                <ui-overlay-load v-if="load" :text="loadText" color="#2d93f8" :size="60" :stroke="8" @click="closeHandle" />
                <slot/>
            </div>
            <!-- After Body -->
            <slot name="afterBody"/>
            <!-- Footer -->
            <div v-if="hasFooter" class="footer">
                <slot name="footer"/>
            </div>
        </div>
    </section>
</template>

<script>
    import { uiOverlayLoad  } from '@/components/ui'
    import uiSidebarTabs from './tabs'
	export default {
        name: 'sidebar-float',
        components: { uiSidebarTabs, uiOverlayLoad},
        props: {
            title: {
                type: String,
                required: true,
            },
            text: {
                type: String,
                required: false,
                default: ''
            },
            name: {
                type: String,
                required: true,
            },
            load: {
                type: Boolean,
                required: false,
                default: false
            },
            loadText: {
                type: String,
                required: false,
                default: ''
            },
            icon: { 
                type: String,
                required: false,
                default: ''
            },
            showOverlay: {
                type: Boolean,
                default: true,
            },
            overlayClose: {
                type: Boolean,
                default: true,
            },
            contentInLoad: {
                type: Boolean,
                required: false,
                default: true,
            },
            position: {
                type: String,
                required: false,
                default: 'right', //top, right, bottom, left
            },
        },
		data(){
			return {
                status: false,
                tabsLabel: [],
                tabsTotal: 0,
                tabCurrent: 0,
                current: null,
            }
        },

        computed: {
            id(){
                return 'ui-sidebar-' + this._uid
            },

			hasFooter(){
				return this.$slots.footer ? true : false
			}
		},
        
        mounted(){
			this.$root.$on('sidebar-open-' + this.name, id => {
				this.open(id)
			})

			this.$root.$on('sidebar-close-' + this.name, () => {
				this.close()
			})

			this.$root.$on('sidebar-toggle-' + this.name, () => {
				this.toggle()
			})

			this.$on('tab-content', id => {
				this.showContent(id)
			})

            this.prepareContents()
        },
        beforeDestroy() {
            this.$root.$off('sidebar-open-'+this.name)
            this.$root.$off('sidebar-close-'+this.name)
            this.$root.$off('sidebar-toggle-'+this.name)
            this.$off('tab-content')
        },
        
        methods: {
            open(id){
                this.status = true
                this.showContent(id)
            },
            close(){
                this.status = false
            },
            toggle(){
                this.status = !this.status
            },
            prepareContents(){
                let sidebar     = this.$refs[this.id]
                let contents    = sidebar.querySelectorAll('[data-title]')
                this.tabsTotal  = contents.length

                for(let i = 0; i < contents.length; i++){
                    let item = {
                        label: contents[i].dataset.title,
                        id: contents[i].dataset.id
                    }
                    this.tabsLabel.push(item)
                }
                
            },
            showContent(id){
                if(!this.tabsTotal) return false

                let sidebar  = this.$refs[this.id]
                let contents = sidebar.querySelectorAll('[data-title]')
                this.current = id
                
                for(let i = 0; i < contents.length; i++){
                    contents[i].classList.remove('active')
                }

                document.querySelector(`[data-id="${id}"]`).classList.add('active')

                this.$emit('tab-active', id)
            },
            closeHandle() {
                this.$root.$emit('sidebar-close-' + this.name)
            }
        }
	}
</script>

<style lang="stylus" scoped>
    @import 'styles.styl'
</style>